module.exports = __webpack_public_path__ + "img/man-img.ad6f96ae.png";